import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Blog.css';

const POSTS = [
  {
    id: 1,
    title: '10 Tips to Teach Boat Guests',
    description: '10 tips to keep everyone safe on your Unimar boat.',
    image: '/unimar-boat-fishing.webp',
    date: 'March 10, 2026',
    category: 'Safety',
  },
  {
    id: 2,
    title: 'Family Adventures on the Water',
    description: 'How to plan the perfect family day out on your boat.',
    image: '/unimar-boat-family.webp',
    date: 'March 5, 2026',
    category: 'Lifestyle',
  },
  {
    id: 3,
    title: 'Cruising the Adriatic: A Guide',
    description: 'Top routes and destinations for your next cruising adventure.',
    image: '/unimar-boat-cruising.webp',
    date: 'February 28, 2026',
    category: 'Travel',
  },
  {
    id: 4,
    title: 'Choosing the Right Boat for You',
    description: 'A complete guide to selecting the perfect Unimar model.',
    image: '/unimar-home-banner.webp',
    date: 'February 20, 2026',
    category: 'Buying Guide',
  },
];

function Blog() {
  return (
    <div className="blog-page">
      <SEO
        title="Blog — Boating Tips, Stories & Guides"
        description="Read the Unimar blog for boating tips, safety guides, and stories from the water. Learn how to care for your fiberglass boat, navigate safely, and get the most out of your Unimar."
        url="/blog"
      />
      <Header />
      <div className="blog-page__hero">
        <h1 className="blog-page__hero-title">Blog</h1>
        <p className="blog-page__hero-sub">Stories, tips & guides from the water</p>
      </div>
      <div className="blog-page__content">
        <div className="blog-page__grid">
          {POSTS.map((post) => (
            <a key={post.id} href={`/blog/${post.id}`} className="blog-page__card">
              <div className="blog-page__card-img-wrapper">
                <img src={post.image} alt={post.title} className="blog-page__card-img" />
              </div>
              <div className="blog-page__card-body">
                <span className="blog-page__card-category">{post.category}</span>
                <h2 className="blog-page__card-title">{post.title}</h2>
                <p className="blog-page__card-desc">{post.description}</p>
                <span className="blog-page__card-date">{post.date}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blog;
